// A local draft sends every change to the frame, which echoes the element back asynchronously and in
// send order. An echo can therefore be older than the draft; it acknowledges its edit and every edit
// sent before it. A value the draft never sent (undo/redo, AI suggestion) is an external change.
// FIXME: Echoes carry no edit id, so this relies on the frame echoing the exact sent value in send order.
// An edit id on page-editor-api's selectedElementUpdated would make matching exact.
export function createDraftEchoes() {
  let pending = [];
  return {
    sent(value) {
      pending.push(value);
    },
    isEcho(value) {
      const i = pending.indexOf(value);
      pending = i === -1 ? [] : pending.slice(i + 1);
      return i !== -1;
    },
  };
}
